export type ChartFocusTooltipPlacement = {
  left: number
  top: number
  side: "left" | "right"
}

const DEFAULT_LINE_GAP = 10
const DEFAULT_EDGE_INSET = 8

export function getChartFocusTooltipPlacement(params: {
  focusX: number
  focusY: number
  chartWidth: number
  chartHeight: number
  bubbleWidth: number
  bubbleHeight: number
  lineGap?: number
  edgeInset?: number
}): ChartFocusTooltipPlacement {
  const {
    focusX,
    focusY,
    chartWidth,
    chartHeight,
    bubbleWidth,
    bubbleHeight,
    lineGap = DEFAULT_LINE_GAP,
    edgeInset = DEFAULT_EDGE_INSET,
  } = params

  const spaceLeft = focusX - edgeInset - lineGap
  const spaceRight = chartWidth - focusX - edgeInset - lineGap

  let placeOnRight: boolean
  if (spaceRight >= bubbleWidth && spaceLeft < bubbleWidth) {
    placeOnRight = true
  } else if (spaceLeft >= bubbleWidth && spaceRight < bubbleWidth) {
    placeOnRight = false
  } else {
    placeOnRight = spaceRight >= spaceLeft
  }

  let left = placeOnRight ? focusX + lineGap : focusX - bubbleWidth - lineGap
  left = Math.max(edgeInset, Math.min(left, chartWidth - bubbleWidth - edgeInset))

  let top = focusY - (bubbleHeight / 2)
  top = Math.max(edgeInset, Math.min(top, chartHeight - bubbleHeight - edgeInset))

  return { left, top, side: placeOnRight ? "right" : "left" }
}
